var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.997 70h-55c-5.14 0-8.333-3.193-8.333-8.333V13.333a3.335 3.335 0 016.667 0v48.334c0 1.496.17 1.666 1.666 1.666h55a3.335 3.335 0 010 6.667z",
    fill: "#0084FF",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 56.667A3.334 3.334 0 0120 53.334v-10a3.334 3.334 0 016.667 0v10a3.335 3.335 0 01-3.334 3.333zM40 53.334V30.001a3.335 3.335 0 00-6.667 0v23.333a3.335 3.335 0 006.667 0zm13.333 0V36.667a3.334 3.334 0 00-6.666 0v16.667a3.334 3.334 0 006.666 0zm13.334 0V16.667a3.335 3.335 0 00-6.667 0v36.667a3.334 3.334 0 006.667 0z",
    fill: "#0084FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessAnalysis);
export default __webpack_public_path__ + "static/media/access-analysis.3cf81ddba9be4c916a7a50e6ef3be28e.svg";
export { ForwardRef as ReactComponent };